export default {
  charts: false,
  currency_toggler: true,
  trades: true,
  trendings: true,
};
